import React from 'react';
import ScoreRing from '../components/ScoreRing';
import Icon from '../components/Icon';
import { WORKSHOPS, SERVICES } from '../data';

export default function HomeScreen({ user, score, scoreColor, scoreLvl, discount, totalRides, avgRating, maxYears, connectedApps, onNavigate, onWorkshopClick }) {

  return (
    <div className="fade-up" style={{ padding:'20px 20px 100px', maxWidth:1200, margin:'0 auto' }}>

      {/* ── Welcome Section ── */}
      <div style={{ marginBottom:32 }}>
        <h2 style={{ fontFamily:'var(--font-display)', fontSize:28, fontWeight:700, color:'#fff', marginBottom:8 }}>
          Olá, {user?.name?.split(' ')[0] || 'Motorista'} 👋
        </h2>
        <p style={{ color:'var(--fg4)', fontSize:16 }}>
          Aqui está um resumo da sua conta e serviços disponíveis.
        </p>
      </div>

      {/* ── Stats Grid ── */}
      <div style={{
        display:'grid',
        gridTemplateColumns:'repeat(auto-fit, minmax(280px, 1fr))',
        gap:24,
        marginBottom:40,
      }}>
        {/* Score Card */}
        <div style={{
          background:'linear-gradient(135deg, rgba(255,92,0,0.15) 0%, rgba(255,92,0,0.05) 100%)',
          border:'1px solid rgba(255,92,0,0.25)',
          borderRadius:'var(--radius-lg)',
          padding:28,
          position:'relative',
          overflow:'hidden',
        }}>
          <div style={{
            position:'absolute', top:-40, right:-40,
            width:200, height:200, borderRadius:'50%',
            background:'radial-gradient(circle, rgba(255,92,0,0.15), transparent 70%)',
            pointerEvents:'none',
          }} />

          <div style={{ display:'flex', alignItems:'center', gap:20, position:'relative' }}>
            <div style={{ position:'relative', display:'flex', alignItems:'center', justifyContent:'center' }}>
              <ScoreRing score={score} color={scoreColor} size={120} />
              <div style={{ position:'absolute', textAlign:'center', pointerEvents:'none' }}>
                <div style={{ fontFamily:'var(--font-display)', fontSize:32, fontWeight:800, color:scoreColor, lineHeight:1 }}>{score}</div>
                <div style={{ fontSize:11, color:'var(--fg4)', fontWeight:600, letterSpacing:'0.06em', marginTop:4 }}>SCORE</div>
              </div>
            </div>

            <div style={{ flex:1 }}>
              <div className="badge badge-orange" style={{ marginBottom:10, fontSize:11 }}>
                <Icon name="star" size={12} style={{ fill:'var(--orange)' }} />
                Nível {scoreLvl}
              </div>
              <div style={{ fontFamily:'var(--font-display)', fontSize:40, fontWeight:800, color:'var(--orange)', lineHeight:1, marginBottom:6 }}>
                {discount}% OFF
              </div>
              <div style={{ fontSize:14, color:'var(--fg3)', marginBottom:14 }}>no próximo serviço</div>
              {!(connectedApps.uber || connectedApps.taxi99) && (
                <button className="btn btn-primary" style={{ padding:'10px 18px', fontSize:14 }} onClick={() => onNavigate('connect')}>
                  <Icon name="link-2" size={16} />
                  Conectar apps
                </button>
              )}
            </div>
          </div>

          {(connectedApps.uber || connectedApps.taxi99) && (
            <div style={{
              display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:12,
              marginTop:24, paddingTop:24,
              borderTop:'1px solid rgba(255,255,255,0.1)',
            }}>
              {[
                [<Icon name="car" size={18} style={{ color:'var(--orange)' }} />, totalRides.toLocaleString('pt-BR'), 'Corridas'],
                [<Icon name="star" size={18} style={{ color:'var(--orange)', fill:'var(--orange)' }} />, avgRating.toFixed(2), 'Avaliação'],
                [<Icon name="calendar" size={18} style={{ color:'var(--orange)' }} />, `${maxYears}a`, 'Ativo há'],
              ].map(([icon, val, lbl]) => (
                <div key={lbl} style={{ textAlign:'center' }}>
                  <div style={{ marginBottom:6 }}>{icon}</div>
                  <div style={{ fontFamily:'var(--font-display)', fontWeight:700, fontSize:18, color:'#fff' }}>{val}</div>
                  <div style={{ fontSize:12, color:'var(--fg4)' }}>{lbl}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* ── Quick Services ── */}
      <div style={{ marginBottom:40 }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
          <h3 style={{ fontFamily:'var(--font-display)', fontWeight:700, fontSize:20, color:'#fff' }}>
            Serviços rápidos
          </h3>
        </div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(140px, 1fr))', gap:14 }}>
          {SERVICES.slice(0,6).map(svc => {
            const iconMap = {
              'Troca de Óleo': 'droplet',
              'Revisão Completa': 'search',
              'Troca de Pneus': 'disc',
              'Alinhamento': 'move-horizontal',
              'Balanceamento': 'scale',
              'Freios': 'octagon',
            };
            const iconName = iconMap[svc.name] || 'wrench';

            return (
              <button key={svc.id} onClick={() => onNavigate('workshops', svc.name)}
                style={{
                  background:'var(--surface)',
                  border:'1px solid var(--border)',
                  borderRadius:'var(--radius-md)',
                  padding:'20px 14px',
                  color:'#fff', textAlign:'center',
                  cursor:'pointer',
                  transition:'var(--transition)',
                  display:'flex',
                  flexDirection:'column',
                  alignItems:'center',
                  gap:12,
                }}
                onMouseEnter={e => { e.currentTarget.style.borderColor='var(--orange)'; e.currentTarget.style.background='var(--orange-dim)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor='var(--border)'; e.currentTarget.style.background='var(--surface)'; }}>
                <Icon name={iconName} size={32} strokeWidth={2} style={{ color:'var(--orange)' }} />
                <div style={{ fontSize:13, fontWeight:600, color:'var(--fg2)', lineHeight:1.3 }}>{svc.name}</div>
              </button>
            );
          })}
        </div>
      </div>

      {/* ── Nearby Workshops ── */}
      <div>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
          <h3 style={{ fontFamily:'var(--font-display)', fontWeight:700, fontSize:20, color:'#fff' }}>Oficinas próximas</h3>
          <button onClick={() => onNavigate('workshops')}
            style={{ background:'none', border:'none', color:'var(--orange)', fontSize:14, fontWeight:600, cursor:'pointer', display:'flex', alignItems:'center', gap:6 }}>
            Ver todas
            <Icon name="arrow-right" size={16} />
          </button>
        </div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(320px, 1fr))', gap:16 }}>
          {WORKSHOPS.slice(0,3).map(w => {
            const iconMap = {
              '🔧': 'wrench', '🛞': 'disc', '⚙️': 'settings',
              '🏎️': 'car', '🛑': 'octagon', '❄️': 'snowflake',
            };
            const iconName = iconMap[w.icon] || 'wrench';

            return (
              <div key={w.id} onClick={() => onWorkshopClick(w)}
                style={{
                  background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius-lg)',
                  padding:'20px', display:'flex', gap:16, alignItems:'center', cursor:'pointer', transition:'var(--transition)',
                }}
                onMouseEnter={e => { e.currentTarget.style.borderColor='rgba(255,92,0,0.35)'; e.currentTarget.style.transform='translateY(-2px)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor='var(--border)'; e.currentTarget.style.transform='translateY(0)'; }}>
                <div style={{
                  width:60, height:60, borderRadius:14,
                  background:'var(--orange-dim)', display:'flex', alignItems:'center', justifyContent:'center',
                  flexShrink:0, border:'1px solid rgba(255,92,0,0.25)',
                }}>
                  <Icon name={iconName} size={32} strokeWidth={2} style={{ color:'var(--orange)' }} />
                </div>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontWeight:600, fontSize:16, color:'#fff', marginBottom:4 }}>{w.name}</div>
                  <div style={{ fontSize:13, color:'var(--fg4)', display:'flex', alignItems:'center', gap:10, marginBottom:6 }}>
                    <span style={{ display:'flex', alignItems:'center', gap:4 }}>
                      <Icon name="map-pin" size={14} />
                      {w.distance}
                    </span>
                    <span>·</span>
                    <span style={{ display:'flex', alignItems:'center', gap:4 }}>
                      <Icon name="star" size={14} style={{ fill:'var(--orange)', color:'var(--orange)' }} />
                      {w.rating}
                    </span>
                    <span>({w.reviews})</span>
                  </div>
                </div>
                <div style={{
                  background:'var(--orange-dim)', color:'var(--orange)',
                  padding:'10px 14px', borderRadius:'var(--radius-sm)',
                  fontSize:16, fontWeight:700, flexShrink:0,
                  border:'1px solid rgba(255,92,0,0.25)',
                }}>-{discount}%</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
